import Slider from '@mui/material/Slider';
import { alpha, styled } from '@mui/material/styles';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { "@mui/material/Slider": Slider, "@mui/material/styles": { alpha, styled } } } });
export default ClientProvider;
